import { cva } from '@/styled-system/css';

export const paginationPageButtonRecipe = cva({
  base: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow 200ms ease, background-color 200ms ease, color 200ms ease',
    },
    width: 'Pagination.PageButton.width',
    height: 'Pagination.PageButton.height',
    backgroundColor: { base: 'Pagination.PageButton.bg.default' },
    borderRadius: 'Pagination.PageButton.default',
    boxShadowColor: { base: 'transparent.invisible' },
    boxShadow: {
      base: 'inset 0 0 0 {sizes.Pagination.PageButton.border} var(--shadow-color)',
      _focusVisible:
        'inset 0 0 0 {sizes.Pagination.PageButton.border} var(--shadow-color), {shadows.focus}',
    },
    color: {
      base: 'Pagination.PageButton.label.default',
    },
    textStyle: 'body-bold',
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
      },
      false: {},
    },
    selected: {
      true: {
        opacity: 1,
        color: { base: 'Pagination.PageButton.label.active' },
        backgroundColor: { base: 'Pagination.PageButton.bg.active' },
        boxShadowColor: { base: 'Pagination.PageButton.border.active' },
      },
      false: {
        cursor: 'pointer',
        color: {
          _hover: 'Pagination.PageButton.label.hover',
          _active: 'Pagination.PageButton.label.pressed',
        },
        backgroundColor: {
          _hover: 'Pagination.PageButton.bg.hover',
          _active: 'Pagination.PageButton.bg.pressed',
        },
        boxShadowColor: {
          _active: 'transparent.invisible',
        },
      },
    },
  },
});
